export default __webpack_public_path__ + "static/media/eeg.39b55b2f.jpg";